<template>
  <router-view />
</template>

<script setup lang="ts">
// Root app component — layout handled by router views
</script>
